import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Table,
  TableBody,
  TableHead,
  Typography,
} from '@material-ui/core'
import React from 'react'
import { ChevronDown } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { EmissionModel } from '../../emission-coefficients/emission-coefficients'
import { emissionPerEnergyUnit } from '../../util/formatters'
import { SidebarAccordionTableRow } from '../common/SidebarAccordionTableRow'
import { useSidebarStyles } from '../pricing-models/use-sidebar-styles'
import CoefficientsSidebarTable, {
  CoefficientsByEnergyType,
} from './CoefficientsSidebarTable'

type Props = {
  coefficientsByEnergyType: CoefficientsByEnergyType[]
  emissionModel: EmissionModel
}

export default function CoefficientsAccordion({
  coefficientsByEnergyType,
  emissionModel,
}: Props): React.ReactElement {
  const classes = useSidebarStyles()
  const { t } = useTranslation()

  return (
    <Accordion square className={classes.accordionTopMargin}>
      <AccordionSummary
        expandIcon={<ChevronDown />}
        className={classes.accordionContentContainer}
      >
        <Typography variant="h6">
          {t('carbonFootprint.emissionModel')}
        </Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.accordionContentContainer}>
        <Box className={classes.accordionContent}>
          <Table>
            <TableHead>
              <SidebarAccordionTableRow
                name={
                  <Typography variant="subtitle1">
                    {t('carbonFootprint.basicInfo.title')}
                  </Typography>
                }
                value={<div />}
                showBorder
              />
            </TableHead>
            <TableBody>
              <SidebarAccordionTableRow
                name={t('carbonFootprint.basicInfo.buildingYear')}
                value={emissionModel.buildingYear}
              />
              <SidebarAccordionTableRow
                name={t('carbonFootprint.basicInfo.inspectionLengthInYears')}
                value={emissionModel.inspectionLengthInYears}
              />
            </TableBody>
          </Table>

          <Box>
            <Typography variant="subtitle1" display="inline">
              {t('carbonFootprint.emissionCoefficients')}
            </Typography>
            <Typography
              variant="subtitle1"
              style={{ textTransform: 'none' }}
              display="inline"
            >
              {` (${emissionPerEnergyUnit})`}
            </Typography>
          </Box>

          {coefficientsByEnergyType.map((coefficients) => (
            <CoefficientsSidebarTable
              key={coefficients.energyType}
              coefficientsByEnergyType={coefficients}
            />
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}
